import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  BarController,
  LineController,
  LineElement,
  PointElement,
} from "chart.js";
import { Col, Container, Row } from "reactstrap";
import { Chart } from "react-chartjs-2";
import { formatCustomDate } from "../../../utils/dateformatter";
import { customAxisPlugin } from "./customAxisPlugin";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  BarController,
  LineController,
  PointElement,
  Tooltip,
  Legend
);

const MixChart = ({ datasetType = ["yakuba", "microgrid"], jsonData }) => {
  const yakuba = jsonData.kushiro_yakuba;
  const microgrid = jsonData.kushiro_microgrid;
  const labels = yakuba?.time;
  const forecast_Datetime = formatCustomDate(jsonData.forecast_datetime);

  const sumArrays = (arr1, arr2) =>
    arr1?.map((val, idx) => {
      const sum = val + (arr2[idx] || 0);
      return Math.round(sum * 10) / 10;
    });

  const chartData = {
    labels,
    datasets: [
      {
        type: "bar",
        label: "需要予測量(kWh)MG",
        data: microgrid.total_demand,
        backgroundColor: "#e47331",
        barPercentage: 0.8,

        yAxisID: "y",
        stack: "demand",
      },

      {
        type: "bar",
        label: "需要予測量(kWh)役場",
        data: yakuba.demand,
        backgroundColor: "#fdba25",
        barPercentage: 0.8,
        yAxisID: "y",
        stack: "demand",
      },

      {
        type: "bar",
        label: "発電予測量(kWh)MG",
        data: microgrid.generation,
        backgroundColor: "#2E7D32",
        barPercentage: 0.8,
        yAxisID: "y",
        stack: "generation",
      },
      {
        type: "bar",
        label: "発電予測量(kWh)役場",
        data: sumArrays(yakuba?.rooftop_gen, yakuba?.carpot_gen),
        backgroundColor: "#66BB6A",
        barPercentage: 0.8,
        yAxisID: "y",
        stack: "generation",
      },

      {
        type: "line",
        label: "購入予測量(kWh)役場",
        data: yakuba?.purchase,
        borderColor: "#d064c4",
        borderWidth: 2,
        tension: 0.1,
        yAxisID: "y",
        pointRadius: 0,
        pointHoverRadius: 5,
      },
      {
        type: "line",
        label: "購入予測量(kWh)MG",
        data: microgrid?.purchase,
        borderColor: "red",
        borderWidth: 2,
        tension: 0.1,
        yAxisID: "y",
        pointRadius: 0,
        pointHoverRadius: 5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      title: {
        display: true,
        text: `${jsonData.request_date} \u00A0\u00A0\u00A0(予測日時: ${forecast_Datetime})\u00A0\u00A0\u00A0釧路町役場 + マイクログリッド`,
        color: "#fff",
        font: {
          size: 14,
          weight: "bold",
        },
      },
      legend: {
        position: "bottom",
        labels: {
          color: "#fff",
          font: {
            size: 10,
          },
        },
      },

      tooltip: { enabled: true },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: "#fff",

          // maxRotation: 90, minRotation: 45,
          maxRotation: 0,
          minRotation: 0,
          font: {
            size: 8,
          },
        },

        grid: {
          display: false,
          drawBorder: true,
        },
      },
      y: {
        type: "linear",
        display: true,
        stacked: true,
        position: "left",
        ticks: {
          color: "#fff",
          padding: 0,
          font: {
            size: 10,
          },
          stepSize: 5,
        },
        title: {
          display: true,
          // text: "kWh",
          color: "#fff",
        },
        grid: { color: "rgba(255,255,255,0.05)" },
      },
    },
  };

  return (
    <Container fluid className="px-5 mt-5">
      <Row>
        <Col md={12}>
          <div
            style={{
              backgroundColor: "#3B3B3B",
              paddingTop: "10px",
              paddingBottom: "10px",
              paddingRight: "0",
              paddingLeft: "0",
              height: "300px",
              width: " 100%",
            }}
          >
            <Chart
              id="myMixChartCanvas"
              type="bar"
              data={chartData}
              options={{ ...options, maintainAspectRatio: false }}
              plugins={[customAxisPlugin]}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MixChart;
